// Keyboard shortcuts help dialog — shows available "g X" navigation shortcuts.
import { NAV_SHORTCUTS } from '@/lib/useKeyboardShortcuts';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@onestone/ui/dialog';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function KeyboardShortcutsDialog({ open, onOpenChange }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xs">
        <DialogHeader>
          <DialogTitle>Keyboard Shortcuts</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-3 pt-2">
          <div>
            <div className="mb-1.5 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
              Navigation
            </div>
            <div className="flex flex-col gap-1">
              {NAV_SHORTCUTS.map((s) => (
                <div key={s.key} className="flex items-center justify-between text-sm">
                  <span className="text-muted-foreground">{s.label}</span>
                  <div className="flex items-center gap-0.5">
                    <kbd className="rounded border border-border bg-muted px-1.5 py-0.5 font-mono text-xs">g</kbd>
                    <kbd className="rounded border border-border bg-muted px-1.5 py-0.5 font-mono text-xs">{s.key}</kbd>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="border-t border-border pt-2">
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">Show this dialog</span>
              <kbd className="rounded border border-border bg-muted px-1.5 py-0.5 font-mono text-xs">?</kbd>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
